import type { ComponentType } from "react";
import { useMemo } from "react";
import { useAuth } from "@/hooks/context/useAuth";
import MainLayout from "@/layouts/MainLayout";
import { useLocation } from "react-router-dom";
import type { AppRole } from "@/types/app-role";

export const ROLE_LAYOUTS: Record<AppRole, ComponentType> = {
  ARTIST: MainLayout,
  VENUE: MainLayout,
  LABEL: MainLayout,
  ADMIN: MainLayout,
};

export const DEFAULT_PATH_BY_ROLE: Record<AppRole, string> = {
  ARTIST: "/dashboard",
  VENUE: "/dashboard",
  LABEL: "/dashboard",
  ADMIN: "/dashboard",
};

export function isPathAllowedForRole(pathname: string, role: AppRole | undefined): boolean {
  void pathname;
  void role;
  return true;
}

export function getDefaultRedirectForRole(role: AppRole): string {
  return DEFAULT_PATH_BY_ROLE[role];
}

export function getLayoutForRole(role: AppRole): ComponentType {
  return ROLE_LAYOUTS[role] ?? MainLayout;
}

export function useUserRole() {
  const { userDetails } = useAuth();
  const location = useLocation();

  return useMemo(() => {
    const pathname = location.pathname;
    const inferredRole = pathname.startsWith("/admin")
      ? "ADMIN"
      : pathname.startsWith("/venue")
        ? "VENUE"
        : pathname.startsWith("/label")
          ? "LABEL"
          : "ARTIST";
    const rawRole = (userDetails?.user_type as AppRole | undefined) ?? inferredRole;
    const Layout = getLayoutForRole(rawRole as AppRole);

    return {
      role: rawRole as AppRole,
      user_type: rawRole as AppRole,
      rawRole: rawRole ?? null,
      isArtist: rawRole === "ARTIST",
      isVenue: rawRole === "VENUE",
      isLabel: rawRole === "LABEL",
      isAdmin: rawRole === "ADMIN",
      Layout,
    };
  }, [location.pathname, userDetails]);
}
